import DIContainer from 'services/DIContainer';
import { OrderCustomFieldRequestDTO, OrderCustomFieldResponseDTO } from 'typings/dto/order';
import DynamicFieldMapper from './DynamicFieldMapper';
import PhoneMapper from './PhoneMapper';
import { DYNAMIC_FIELD_RESPONSE_TYPE, DYNAMIC_FIELD_TYPE, DYNAMIC_FIELD_VALUE_TYPE } from 'typings/subEntities/dynamicField.enum';
import FunctionUtils from '../../Function';

export default class OrderCustomFieldMapper {
  constructor(private dynamicFieldMapper: DynamicFieldMapper, private phoneMapper: PhoneMapper) {}

  public responseDTOToModel = (dto: OrderCustomFieldResponseDTO, outerMappers: DIContainer.Mappers['models']): Order.CustomField => {
    let optionsSelectAndRadiogroup: EntityWithName[] = [];
    if (dto.settings.options) {
      optionsSelectAndRadiogroup = dto.settings.options.map((item) => {
        return { id: item.technicalName, name: item.name };
      });
    }
    const model: Order.CustomField = {
      id: dto.id,
      technicalName: dto.technicalName,
      type: dto.type,
      multiple: dto.multiple,
      required: dto.required,
      editable: dto.editable,
      name: dto.name,
      settings: {
        ...dto.settings,
        options: optionsSelectAndRadiogroup,
        labelFalse: dto.settings.labelFalse,
        labelTrue: dto.settings.labelTrue,
        defaultValue: dto.settings.defaultValue,
      },
      dynamicField: this.dynamicFieldMapper.responseDTOToModel(dto.dynamicFieldSettings, outerMappers),
      tenant: dto.tenant,
      category: dto.category ? dto.category : null,
      showInSessionByOrderType: dto.showInSessionByOrderType,
      showInOrderByOrderType: dto.showInOrderByOrderType,
    };

    return model;
  };

  public modelToRequestDTO = (entity: Order.CustomField): OrderCustomFieldRequestDTO => {
    let optionsSelectAndRadiogroup: { technicalName: string; name: string }[] | undefined;
    if (entity.settings.options) {
      optionsSelectAndRadiogroup = entity.settings.options.map((item) => {
        return { technicalName: item.id, name: item.name };
      });
    }
    return {
      id: entity.id,
      technicalName: entity.technicalName,
      type: entity.type,
      multiple: entity.multiple,
      required: entity.required,
      name: entity.name,
      settings: entity.settings && {
        options: optionsSelectAndRadiogroup,
      },
      editable: entity.editable,
      category: entity.category,
      showInSessionByOrderType: entity.showInSessionByOrderType,
      showInOrderByOrderType: entity.showInOrderByOrderType,
    };
  };
}
